import { render, staticRenderFns } from "./TermsAgree.vue?vue&type=template&id=20556f48&"
import script from "./TermsAgree.vue?vue&type=script&lang=js&"
export * from "./TermsAgree.vue?vue&type=script&lang=js&"
import style0 from "./TermsAgree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports